import { getCurrentInstance } from 'vue';
import { PermissionsService } from '@/services/permissions.service';

export function usePermissionsService(): PermissionsService {
  const keycloak = getCurrentInstance()?.appContext.config.globalProperties.$keycloak;

  return new PermissionsService(keycloak);
}
